import React from 'react';
import { Pagination as AntdPagination } from 'antd';
import 'antd/lib/select/style/index.css';
import 'antd/lib/pagination/style/index.css';
import './animations.css';

export function Pagination(props) {
  return (
    <AntdPagination {...props} />
  );
}
